import React, { useEffect, useRef } from 'react';
import { Panel } from 'primereact/panel';

import SoldAvmCompsTable from '../common/SoldAvmCompsTable';
import ActiveAvmCompsTable from '../common/ActiveAvmCompsTable';
import { useAvmContext } from '../../contexts/DecisionMaking/AvmContext';

const headerStyling =
  'flex items-center justify-center align-middle text-white p-1 pb-2';
const contentStyling = 'p-0 overflow-scroll';
const titleStyling = 'anchor-center w-full';
const togglerStyling = 'text-white';

const DecisionMakingCompsContainer = () => {
  const refTopSixSoldComps = useRef<Panel>(null);
  const refTopSixActiveComps = useRef<Panel>(null);
  const { soldCompsSix, activeCompsSix } = useAvmContext();

  useEffect(() => {
    refTopSixSoldComps.current?.collapse(null);
    refTopSixActiveComps.current?.collapse(null);
  }, [refTopSixSoldComps, refTopSixActiveComps]);

  const headerFormat = (header: string, ref: React.RefObject<Panel>) => {
    return (
      <div
        onClick={() => {
          if (ref.current) {
            ref.current?.toggle(null);
          }
        }}
        className="flex items-center justify-center align-middle"
      >
        <h3 className="text-lg font-bold">{header}</h3>
      </div>
    );
  };

  return (
    <div id="decision-making-comps-container" className="mx-4">
      <Panel
        ref={refTopSixSoldComps}
        pt={{
          header: {
            className: `bg-indigo-950 ${headerStyling}`,
          },
          content: {
            className: contentStyling,
          },
          title: {
            className: titleStyling,
          },
          toggler: {
            className: togglerStyling,
          },
        }}
        header={headerFormat('AVM Top 6 Sold Comps', refTopSixSoldComps)}
        toggleable
      >
        <SoldAvmCompsTable comps={soldCompsSix} />
      </Panel>
      <hr className="my-4" />
      <Panel
        ref={refTopSixActiveComps}
        pt={{
          header: {
            className: `bg-indigo-600 ${headerStyling}`,
          },
          content: {
            className: contentStyling,
          },
          title: {
            className: titleStyling,
          },
          toggler: {
            className: togglerStyling,
          },
        }}
        header={headerFormat('AVM Top 6 Active Comps', refTopSixActiveComps)}
        toggleable
      >
        <ActiveAvmCompsTable comps={activeCompsSix} />
      </Panel>
    </div>
  );
};

export default DecisionMakingCompsContainer;
